import React from "react";
import { connect } from "react-redux";

import ByTerryOrders from "./ByTerryOrders";

const ByTerryOrdersContainer = props => {
  return <ByTerryOrders {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(ByTerryOrdersContainer);



// WEBPACK FOOTER //
// src/pages/sidely/ByTerryOrders.container.js